
<div class="app-layout">
  <app-header></app-header>

  <div class="app-content">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
